import { IReviewStorage } from '../interfaces/IReviewStorage';
import { DataStorage } from '@studyportals/data-storage';

const getLocalStorage = async (): Promise<IReviewStorage> => {
	const storageSerialized = (await DataStorage.retrieve('Reviews')) as string | undefined;
	const storage: IReviewStorage = storageSerialized
		? (JSON.parse(storageSerialized) as IReviewStorage)
		: ({} as IReviewStorage);

	return storage;
};

export { getLocalStorage };
